import { Component, Input } from '@angular/core';
import { Queue } from '@app/core/interfaces/c5/acd/queue';
import { ContextSwitchTypeaheadEntry } from '@app/menu/components/context-switcher/context-switch-typeahead-entry';
import { MenuService } from '@app/menu/services/menu.service';
import { TypeaheadEntry } from '@app/shared/services/typeahead-basket.service';

@Component({
  selector: 'portal-call-center-queue-switcher',
  templateUrl: './call-center-queue-switcher.component.html',
  styles: [],
  standalone: false,
})
export class CallCenterQueueSwitcherComponent {
  @Input()
  public callCenterId: number;

  @Input()
  public queue: Queue;

  @Input()
  public queues: TypeaheadEntry<number>[];

  constructor(private menuService: MenuService) {}

  public switchRoute(typeaheadEntry: ContextSwitchTypeaheadEntry) {
    if (typeaheadEntry.value !== this.queue.id) {
      this.menuService.switch('queueId', {
        callCenterId: this.callCenterId,
        queueId: typeaheadEntry.value,
      });
    }
  }
}
